import React from 'react';

import PlaceholderTab from '../../shared/PlaceholderTab';

import { BLACKOUT_DATE_FIELDS } from './fields';

export default function BlackoutDatesTab() {
  return <PlaceholderTab configuredFieldCount={BLACKOUT_DATE_FIELDS.length} title="Blackout Dates" />;
}
